// TODO: This component can be a good candidate to move inside pt-skel

import React, { ReactNode } from 'react'

// Configuration interface for what each individual tab slot contains
export interface TabConfig {
  title: string;
  content: ReactNode;
}

// TabsProps contains a mapping between the tabId and tab config and others
interface TabsProps<T extends string> {
  tabs: Record<T, TabConfig>;
  activeTabId: T;
  onTabChange: (tabId: T) => void;
}

function getActiveTabContent<T extends string> (tabs: Record<T, TabConfig>, activeTabId: T):ReactNode {
  const activeContent = tabs[activeTabId]?.content
  if (!activeContent) {
    throw new Error(`Invalid tabId is provided: ${activeTabId}`)
  }
  return activeContent
}

export function HorizontalTabs<T extends string> ({ tabs, activeTabId, onTabChange }: TabsProps<T>): React.JSX.Element {
  const activeContent = getActiveTabContent(tabs, activeTabId)

  // list all the tabIds to render all the tabs in the UI
  const tabIds = Object.keys(tabs) as T[]
  return (
    <>
      {/* Render Tab Navigation Headers and Control */}
      <div className="horizontal-tab-header" style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
        {tabIds.map((currTabId) => (
          <div
            id={currTabId}
            key={currTabId}
            className={`horizontal-tab-item ${activeTabId === currTabId ? 'active' : ''}`}
            onClick={() => onTabChange(currTabId)}
            style={{
              cursor: 'pointer',
              paddingBottom: '8px',
              fontWeight: activeTabId === currTabId ? 'bold' : 'normal',
              borderBottom: activeTabId === currTabId ? '3px solid #0076b6' : '3px solid transparent',
            }}
          >
            {tabs[currTabId].title}
          </div>
        ))}
      </div>

      {/* Render Tab Content Panel */}
      <div className="horizontal-tab-content">
        {activeContent}
      </div>
    </>
  )
}
